import { render, staticRenderFns } from "./LogEvents.vue?vue&type=template&id=5ace672a&scoped=true"
import script from "./LogEvents.vue?vue&type=script&lang=js"
export * from "./LogEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace672a",
  null
  
)

export default component.exports